module.exports = __webpack_public_path__ + "static/problem1-6cd3b707bf482af351ba2cae4f0e0dce.svg";